import { render } from "./AddServiceListing.vue?vue&type=template&id=0853b0e3&scoped=true"
const script = {}

import "./AddServiceListing.vue?vue&type=style&index=0&id=0853b0e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0853b0e3"]])

export default __exports__